'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024103 from "./presto.types$$anon$103.js";
import * as $j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024 from "./presto.types$-Day-Of-Week-Utils$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
import * as $j_presto$002etypes$0024$002dWeek$002dDay$002dPayload$0024 from "./presto.types$-Week-Day-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$102(outer) {
  this.c9x = null;
  this.c9p = null;
  this.c9q = false;
  this.c9y = null;
  this.c9z = false;
  this.c9C = null;
  this.c9v = null;
  this.c9w = false;
  this.c9r = null;
  this.c9s = false;
  this.c9t = null;
  this.c9u = false;
  this.c9A = false;
  this.c9B = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.c9x = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c9C = "WeekDayPayload";
}
export { $c_Lpresto_types$Rule$$anon$102 as $c_Lpresto_types$Rule$$anon$102 };
$p = $c_Lpresto_types$Rule$$anon$102.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$102;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$102() {
}
export { $h_Lpresto_types$Rule$$anon$102 as $h_Lpresto_types$Rule$$anon$102 };
$h_Lpresto_types$Rule$$anon$102.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c9x;
});
$p.L = (function() {
  if ((!this.c9q)) {
    this.c9p = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c9q = true;
  }
  return this.c9p;
});
$p.O = (function() {
  if ((!this.c9z)) {
    this.c9y = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c9z = true;
  }
  return this.c9y;
});
$p.E = (function() {
  return this.c9C;
});
$p.t = (function() {
  if ((!this.c9w)) {
    this.c9v = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("days", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c9w = true;
  }
  return this.c9v;
});
$p.M = (function() {
  if ((!this.c9s)) {
    this.c9r = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().SM(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024.$m_Lpresto_types$DayOfWeekUtils$().cHG())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c9s = true;
  }
  return this.c9r;
});
$p.Q = (function() {
  if ((!this.c9u)) {
    this.c9t = new $j_presto$002etypes$0024$0024anon$0024103.$c_Lpresto_types$$anon$103();
    this.c9u = true;
  }
  return this.c9t;
});
$p.w = (function() {
  if ((!this.c9B)) {
    this.c9A = false;
    this.c9B = true;
  }
  return this.c9A;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee159) => ((p) => \u03b4scrutinee159.cGD(p)))($j_presto$002etypes$0024$002dWeek$002dDay$002dPayload$0024.$m_Lpresto_types$WeekDayPayload$())));
});
var $d_Lpresto_types$Rule$$anon$102 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$102, "presto.types$Rule$$anon$102", ({
  a18: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$102 as $d_Lpresto_types$Rule$$anon$102 };
//# sourceMappingURL=presto.types$-Rule$$anon$102.js.map
